/** @see app/common/enums/catalog/ModifierSwitchMethodTypeEnum */

export const ModifierSwitchMethodTypeEnum = {
    single: 1,
    multi: 2,
};